<template>
  <div>
    <div class="com-banner" style="background-image:url(https://fs.58keeper.com/contact-bg.jpg)">
      <div class="banner-inner center">
        <h1>联系托管</h1>
        <p>专注房屋管理，免费养护，长短租经营，创造价值</p>
      </div>
    </div>
    <div class="section contact-section">
      <div class="com-container">
        <div class="t-center">
          <h2 style="color: red;">{{msg}}</h2>
          <p>我们会尽快给您致电<br>
            您也可以主动通过以下方式联系
          </p>
          <p class="mt-30"><a href="tel:18621703105">石经理：18621703105</a></p>
          <p><a href="mailto:shiguodong@58keeper.com">shiguodong@58keeper.com</a></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
let _self
export default {
  name: 'result',
  data: function () {
    return {
      msg: ''
    }
  },
  methods: {},
  mounted () {
    _self = this
    _self.msg = _self.$route.query.msg
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Result.vue